import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "price-list",
  "aria-live": "polite"
}
const _hoisted_2 = { class: "price" }
const _hoisted_3 = {
  key: 1,
  class: "price-list__price-infos"
}
const _hoisted_4 = { class: "price" }
const _hoisted_5 = {
  key: 2,
  class: "price-list__total-price"
}
const _hoisted_6 = { class: "price-list__total-price-label" }
const _hoisted_7 = {
  key: 3,
  class: "price-list__order-bonuses"
}
const _hoisted_8 = { class: "price-list__order-bonuses-cell" }
const _hoisted_9 = { class: "price-list__order-bonuses-cell" }
const _hoisted_10 = {
  key: 4,
  class: "price-list-caption"
}
const _hoisted_11 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.showPredefinedPrices && _ctx.showPriceList)
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.salesCampaign.priceInfos, (price, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "price-list__price-infos",
            key: index
          }, [
            _createElementVNode("span", null, _toDisplayString(price.description), 1),
            _createElementVNode("span", _hoisted_2, _toDisplayString(price.price), 1)
          ]))
        }), 128))
      : (
        _ctx.showCalculatedPrices && _ctx.monthlyPriceGreaterThanZero && _ctx.showPriceList
      )
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("span", null, _toDisplayString(_ctx.monthlyPriceLabel), 1),
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.monthlyPrice), 1)
          ]))
        : _createCommentVNode("", true),
    (_ctx.totalPrice !== '' && _ctx.showCalculatedPrices && _ctx.showPriceList)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.commonTexts.userFrontend.priceList.totalLabel), 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.totalPrice), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.displayOrderBonusCart)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bonusCart, (selectedBonus) => {
            return (_openBlock(), _createElementBlock("div", {
              key: selectedBonus.bonus.materialNumber,
              class: "price-list__order-bonuses-row"
            }, [
              _createElementVNode("span", _hoisted_8, _toDisplayString(selectedBonus.bonus.title), 1),
              _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.renderPrice(selectedBonus.bonus.additionalCharges[0].value)), 1)
            ]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    (_ctx.productIsWithCosts && _ctx.valueAddedTaxText)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("span", { innerHTML: _ctx.valueAddedTaxText }, null, 8, _hoisted_11)
        ]))
      : _createCommentVNode("", true)
  ]))
}